import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { ProviderData } from '@openx/types/provider';
import { useTranslation } from 'react-i18next';

import { getProvidersLabels, providerFields } from '../../constants';
import { AllowedExportTypesField } from '../components/AllowedExportTypesField';

type ProviderDetailsSectionProps = {
  provider: ProviderData;
};

export const ProviderDetailsSection = ({ provider }: ProviderDetailsSectionProps) => {
  const { t } = useTranslation();
  const providersLabels = getProvidersLabels(t);

  return (
    <FormSection divider title={t('Provider Details')}>
      <FieldDetails title={providersLabels[providerFields.ID]} value={provider.id} />
      <FieldDetails title={providersLabels[providerFields.NAME]} value={provider.name} />
      <AllowedExportTypesField allowedExportTypes={provider.allowed_export_types} />
    </FormSection>
  );
};
